import React, { Component } from "react";
import Chart from "chart.js";
import classes from "./Chart_Village_Species_BarChart.module.css";
import { stockData } from "../../assets/data";

var countAlligator = 0; var countAnteater = 0;
var countBear = 0; var countBird = 0; var countBull = 0;
var countCat = 0; var countChicken = 0; var countCow = 0; var countCub = 0;
var countDeer = 0; var countDog = 0; var countDuck = 0; 
var countEagle = 0; var countElephant = 0;
var countFrog = 0;
var countGoat = 0; var countGorilla = 0;
var countHamster = 0; var countHippo = 0; var countHorse = 0; 
var countKangeroo = 0; var countKoala = 0; 
var countLion = 0;
var countMonkey = 0; var countMouse = 0;
var countOctopus = 0; var countOstrich = 0;
var countPenguin = 0; var countPig = 0;
var countRabbit = 0; var countRhino = 0;
var countSheep = 0; var countSquirrel = 0;
var countTiger = 0; 
var countWolf = 0;

var countAlligatorM = 0; var countAnteaterM = 0;
var countBearM = 0; var countBirdM = 0; var countBullM = 0;
var countCatM = 0; var countChickenM = 0; var countCowM = 0; var countCubM = 0;
var countDeerM = 0; var countDogM = 0; var countDuckM = 0; 
var countEagleM = 0; var countElephantM = 0;
var countFrogM = 0;
var countGoatM = 0; var countGorillaM = 0;
var countHamsterM = 0; var countHippoM = 0; var countHorseM = 0; 
var countKangerooM = 0; var countKoalaM = 0; 
var countLionM = 0;
var countMonkeyM = 0; var countMouseM = 0;
var countOctopusM = 0; var countOstrichM = 0;
var countPenguinM = 0; var countPigM = 0;
var countRabbitM = 0; var countRhinoM = 0;
var countSheepM = 0; var countSquirrelM = 0;
var countTigerM = 0; 
var countWolfM = 0;

function getRandomColor() {
    var letters = '0123456789ABCDEF'.split('');
    var color = '#'; // '#'
    for (var i = 0; i < 6; i++ ) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
var myColors_array = [];
var c;
for(c=0; c<35; c++) {
    var myColorResult = getRandomColor();
    myColors_array[c] = myColorResult;
    
}
console.log(myColors_array);

var myNumFVillSpecies_array = [];
var myNumMVillSpecies_array = [];
var myVillSpecies_array = [
        'Alligator', 'Anteater',
        'Bear', 'Bird', 'Bull',
        'Cat', 'Chicken', 'Cow', 'Cub',
        'Deer', 'Dog', 'Duck',
        'Eagle', 'Elephant',
        'Frog',
        'Goat', 'Gorilla',
        'Hamster', 'Hippo', 'Horse',
        'Kangaroo', 'Koala',
        'Lion',
        'Monkey', 'Mouse',
        'Octopus', 'Ostrich',
        'Penguin', 'Pig',
        'Rabbit', 'Rhino',
        'Sheep', 'Squirrel',
        'Tiger',
        'Wolf'   
    ];

stockData.map((data, key) => {
    if (data.gender == 'Female') {
        if (data.species.trim() == 'Alligator') {
            countAlligator = countAlligator + 1;
            myNumFVillSpecies_array[0] = countAlligator;
        }
        if (data.species.trim() == 'Anteater') {
            countAnteater = countAnteater + 1;
            myNumFVillSpecies_array[1] = countAnteater;
        } 
        if (data.species.trim() == 'Bear') {
            countBear = countBear + 1;
            myNumFVillSpecies_array[2] = countBear;
        } 
        if (data.species.trim() == 'Bird') {
            countBird = countBird + 1;
            myNumFVillSpecies_array[3] = countBird;
        }
        if (data.species.trim() == 'Bull') {
            countBull = countBull + 1;
            myNumFVillSpecies_array[4] = countBull;
        } 
        if (data.species.trim() == 'Cat') {
            countCat = countCat + 1;
            myNumFVillSpecies_array[5] = countCat;
        } 
        if (data.species.trim() == 'Chicken') {
            countChicken = countChicken + 1;
            myNumFVillSpecies_array[6] = countChicken;
        } 
        if (data.species.trim() == 'Cow') {
            countCow = countCow + 1;
            myNumFVillSpecies_array[7] = countCow;
        } 
        if (data.species.trim() == 'Cub') {
            countCub = countCub + 1;
            myNumFVillSpecies_array[8] = countCub;
        } 
        if (data.species.trim() == 'Deer') {
            countDeer = countDeer + 1;
            myNumFVillSpecies_array[9] = countDeer;
        } 
        if (data.species.trim() == 'Dog') {
            countDog = countDog + 1;
            myNumFVillSpecies_array[10] = countDog;
        } 
        if (data.species.trim() == 'Duck') {
            countDuck = countDuck + 1;
            myNumFVillSpecies_array[11] = countDuck;
        }    
        if (data.species.trim() == 'Eagle') {
            countEagle = countEagle + 1;
            myNumFVillSpecies_array[12] = countEagle;
        }  
        if (data.species.trim() == 'Elephant') {
            countElephant = countElephant + 1;
            myNumFVillSpecies_array[13] = countElephant;
        }  
        if (data.species.trim() == 'Frog') {
            countFrog = countFrog + 1;
            myNumFVillSpecies_array[14] = countFrog;
        }  
        if (data.species.trim() == 'Goat') {
            countGoat = countGoat + 1;
            myNumFVillSpecies_array[15] = countGoat;
        }  
        if (data.species.trim() == 'Gorilla') {
            countGorilla = countGorilla + 1;
            myNumFVillSpecies_array[16] = countGorilla;
        }  
        if (data.species.trim() == 'Hamster') {
            countHamster = countHamster + 1;
            myNumFVillSpecies_array[17] = countHamster;
        }  
        if (data.species.trim() == 'Hippo') {
            countHippo = countHippo + 1;
            myNumFVillSpecies_array[18] = countHippo;
        } 
        if (data.species.trim() == 'Horse') {
            countHorse = countHorse + 1;
            myNumFVillSpecies_array[19] = countHorse;
        }    
        if (data.species.trim() == 'Kangeroo') {
            countKangeroo = countKangeroo + 1;
            myNumFVillSpecies_array[20] = countKangeroo;
        }  
        if (data.species.trim() == 'Koala') {
            countKoala = countKoala + 1;
            myNumFVillSpecies_array[21] = countKoala;
        } 
        if (data.species.trim() == 'Lion') {
            countLion = countLion + 1;
            myNumFVillSpecies_array[22] = countLion;
        } 
        if (data.species.trim() == 'Monkey') {
            countMonkey = countMonkey + 1;
            myNumFVillSpecies_array[23] = countMonkey;
        } 
        if (data.species.trim() == 'Mouse') {
            countMouse = countMouse + 1;
            myNumFVillSpecies_array[24] = countMouse;
        } 
        if (data.species.trim() == 'Octopus') {
            countOctopus = countOctopus + 1;
            myNumFVillSpecies_array[25] = countOctopus;
        } 
        if (data.species.trim() == 'Ostrich') {
            countOstrich = countOstrich + 1;
            myNumFVillSpecies_array[26] = countOstrich;
        } 
        if (data.species.trim() == 'Penguin') {
            countPenguin = countPenguin + 1;
            myNumFVillSpecies_array[27] = countPenguin;
        } 
        if (data.species.trim() == 'Pig') {
            countPig = countPig + 1;
            myNumFVillSpecies_array[28] = countPig;
        } 
        if (data.species.trim() == 'Rabbit') {
            countRabbit = countRabbit + 1;
            myNumFVillSpecies_array[29] = countRabbit;
        } 
        if (data.species.trim() == 'Rhino') {
            countRhino = countRhino + 1;
            myNumFVillSpecies_array[30] = countRhino;
        } 
        if (data.species.trim() == 'Sheep') {
            countSheep = countSheep + 1;
            myNumFVillSpecies_array[31] = countSheep;
        } 
        if (data.species.trim() == 'Squirrel') {
            countSquirrel = countSquirrel + 1;
            myNumFVillSpecies_array[32] = countSquirrel;
        } 
        if (data.species.trim() == 'Tiger') {
            countTiger = countTiger + 1;
            myNumFVillSpecies_array[33] = countTiger;
        } 
        if (data.species.trim() == 'Wolf') {
            countWolf = countWolf + 1;
            myNumFVillSpecies_array[34] = countWolf;
        }
    } else {
        if (data.species.trim() == 'Alligator') {
            countAlligatorM = countAlligatorM + 1;
            myNumMVillSpecies_array[0] = countAlligatorM;
        }
        if (data.species.trim() == 'Anteater') {
            countAnteaterM = countAnteaterM + 1;
            myNumMVillSpecies_array[1] = countAnteaterM;
        } 
        if (data.species.trim() == 'Bear') {
            countBearM = countBearM + 1;
            myNumMVillSpecies_array[2] = countBearM;
        } 
        if (data.species.trim() == 'Bird') {
            countBirdM = countBirdM + 1;
            myNumMVillSpecies_array[3] = countBirdM;
        }
        if (data.species.trim() == 'Bull') {
            countBullM = countBullM + 1;
            myNumMVillSpecies_array[4] = countBullM;
        } 
        if (data.species.trim() == 'Cat') {
            countCatM = countCatM + 1;
            myNumMVillSpecies_array[5] = countCatM;
        } 
        if (data.species.trim() == 'Chicken') {
            countChickenM = countChickenM + 1;
            myNumMVillSpecies_array[6] = countChickenM;
        } 
        if (data.species.trim() == 'Cow') {
            countCowM = countCowM + 1;
            myNumMVillSpecies_array[7] = countCowM;
        } 
        if (data.species.trim() == 'Cub') {
            countCubM = countCubM + 1;
            myNumMVillSpecies_array[8] = countCubM;
        } 
        if (data.species.trim() == 'Deer') {
            countDeerM = countDeerM + 1;
            myNumMVillSpecies_array[9] = countDeerM;
        } 
        if (data.species.trim() == 'Dog') {
            countDogM = countDogM + 1;
            myNumMVillSpecies_array[10] = countDogM;
        } 
        if (data.species.trim() == 'Duck') {
            countDuckM = countDuckM + 1;
            myNumMVillSpecies_array[11] = countDuckM;
        }    
        if (data.species.trim() == 'Eagle') {
            countEagleM = countEagleM + 1;
            myNumMVillSpecies_array[12] = countEagleM;
        }  
        if (data.species.trim() == 'Elephant') {
            countElephantM = countElephantM + 1;
            myNumMVillSpecies_array[13] = countElephantM;
        }  
        if (data.species.trim() == 'Frog') {
            countFrogM = countFrogM + 1;
            myNumMVillSpecies_array[14] = countFrogM;
        }  
        if (data.species.trim() == 'Goat') {
            countGoatM = countGoatM + 1;
            myNumMVillSpecies_array[15] = countGoatM;
        }  
        if (data.species.trim() == 'Gorilla') {
            countGorillaM = countGorillaM + 1;
            myNumMVillSpecies_array[16] = countGorillaM;
        }  
        if (data.species.trim() == 'Hamster') {
            countHamsterM = countHamsterM + 1;
            myNumMVillSpecies_array[17] = countHamsterM;
        }  
        if (data.species.trim() == 'Hippo') {
            countHippoM = countHippoM + 1;
            myNumMVillSpecies_array[18] = countHippoM;
        } 
        if (data.species.trim() == 'Horse') {
            countHorseM = countHorseM + 1;
            myNumMVillSpecies_array[19] = countHorseM;
        }    
        if (data.species.trim() == 'Kangeroo') {
            countKangerooM = countKangerooM + 1;
            myNumMVillSpecies_array[20] = countKangerooM;
        }  
        if (data.species.trim() == 'Koala') {
            countKoalaM = countKoalaM + 1;
            myNumMVillSpecies_array[21] = countKoalaM;
        } 
        if (data.species.trim() == 'Lion') {
            countLionM = countLionM + 1;
            myNumMVillSpecies_array[22] = countLionM;
        } 
        if (data.species.trim() == 'Monkey') {
            countMonkeyM = countMonkeyM + 1;
            myNumMVillSpecies_array[23] = countMonkeyM;
        } 
        if (data.species.trim() == 'Mouse') {
            countMouseM = countMouseM + 1;
            myNumMVillSpecies_array[24] = countMouseM;
        } 
        if (data.species.trim() == 'Octopus') {
            countOctopusM = countOctopusM + 1;
            myNumMVillSpecies_array[25] = countOctopusM;
        } 
        if (data.species.trim() == 'Ostrich') {
            countOstrichM = countOstrichM + 1;
            myNumMVillSpecies_array[26] = countOstrichM;
        } 
        if (data.species.trim() == 'Penguin') {
            countPenguinM = countPenguinM + 1;
            myNumMVillSpecies_array[27] = countPenguinM;
        } 
        if (data.species.trim() == 'Pig') {
            countPigM = countPigM + 1;
            myNumMVillSpecies_array[28] = countPigM;
        } 
        if (data.species.trim() == 'Rabbit') {
            countRabbitM = countRabbitM + 1;
            myNumMVillSpecies_array[29] = countRabbitM;
        } 
        if (data.species.trim() == 'Rhino') {
            countRhinoM = countRhinoM + 1;
            myNumMVillSpecies_array[30] = countRhinoM;
        } 
        if (data.species.trim() == 'Sheep') {
            countSheepM = countSheepM + 1;
            myNumMVillSpecies_array[31] = countSheepM;
        } 
        if (data.species.trim() == 'Squirrel') {
            countSquirrelM = countSquirrelM + 1;
            myNumMVillSpecies_array[32] = countSquirrelM;
        } 
        if (data.species.trim() == 'Tiger') {
            countTigerM = countTigerM + 1;
            myNumMVillSpecies_array[33] = countTigerM;
        } 
        if (data.species.trim() == 'Wolf') {
            countWolfM = countWolfM + 1;
            myNumMVillSpecies_array[34] = countWolfM;
        }        
    }     
});
console.log('countAlligator: ' + countAlligator);
console.log('countWolf: ' + countWolf);

export default class VillagersSpecies_Chart extends Component {
    chartRef = React.createRef();

    componentDidMount() {
        const myChartRef = this.chartRef.current.getContext("2d"); 

        new Chart(myChartRef, {
            type: "line",
            data: {
                //Bring in data
                labels: myVillSpecies_array, 
                datasets: [{
                    fillOpacity: 0.1,
                    label: 'Female',  
                    data: myNumFVillSpecies_array,    		
                    backgroundColor: "rgba(255, 99, 132, 0.5)",
                    borderColor: "rgba(255, 99, 132, 0.5)",
                    borderWidth: 1,
                    fill: false,
                    lineTension: 0.3              
                  }, 
                  {
                    fillOpacity: 0.1,
                    label: 'Male',  
                    data: myNumMVillSpecies_array,    		
                    backgroundColor: "rgba(54, 162, 235, 0.5)",
                    borderColor: "rgba(54, 162, 235, 0.5)",
                    borderWidth: 1,
                    fill: false,
                    lineTension: 0.0              
                  }


                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                scales: {
                  xAxes: [{
                      ticks: { 
                        beginAtZero: true,
                        autoSkip: false,
                        maxRotation: 90,
                        minRotation: 90   
                      }

                  }]  
                    
                }
              }
        });
    
    
    }
    render() {
        return (
            <div className={classes.graphContainer}>
                <canvas
                    id="myChart"
                    ref={this.chartRef}
                />
            </div>

        )
    }   
}    